import ApiService from '@/services/api.service'

const MdCountriesService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/MdCountries/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    },  
    getMdCountries(){
         return ApiService.get(`/MdCountries`);
    },
    Add(data){
        return ApiService.post(`/MdCountries`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/MdCountries/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/MdCountries/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/MdCountries/${Id}`);
    }
  }


  
  export default MdCountriesService;